const getMainOwner = (owners) => {
  // count the owner-codes
  const ownersObject = owners.reduce((acc, curr) => {
    if (typeof acc[curr] === 'undefined') {
      acc[curr] = 1
    } else {
      acc[curr] += 1
    }
    return acc
  }, {})

  // get key of highest owner-code-count
  const mainOwner = Object.keys(ownersObject).reduce((a, b) => {
    return ownersObject[a] >= ownersObject[b] ? a : b
  })

  return mainOwner
}

export default getMainOwner



// WEBPACK FOOTER //
// ./src/logic/getMainOwner.js